import { combineReducers, type ThunkDispatch, type UnknownAction } from '@reduxjs/toolkit'

import { ownCashierSliceReducer } from './features/cashier/model/cashierSlice'
import { ownOperationSliceReducer } from './features/operation/model/operationSlice'
import { ownPaymentAttemptSliceReducer } from './features/sale/model/paymentAttemptSlice'
import { ownSaleSliceReducer } from './features/sale/model/saleSlice'
import { ownSaleSnapshotsReducer } from './features/snapshot/model/snapshotSlice'

/**
 * Состояние модуля `own` — только намерения человека (CLAUDE.md §7), по слайсу на сущность окна продажи:
 * - `sale` — корзина, способ оплаты, поиск, этап продажи (`screen`);
 * - `operation` — формы и отказ агента под «Подробнее», заметки после продажи (`screen`);
 * - `paymentAttempt` — попытка оплаты: окно на одно нажатие, «Свернуть», «Закрыть», «команда не ушла» (`screen`, RP-PAY-ONE);
 * - `cashier` — выбранный кассир и подтверждение PIN-ом (`screen`, без PIN и токена);
 * - `saleSnapshots` — снимок строк чека на начало операции: F5 не теряет, что именно пробивалось (`session`, RP-OWN4).
 * Данные сервера (каталог, цены, ставки, кассиры-администраторы) — в кэше RTK Query; сессия агента — в памяти контроллера.
 */
export const ownUiReducer = combineReducers({
  sale: ownSaleSliceReducer,
  operation: ownOperationSliceReducer,
  paymentAttempt: ownPaymentAttemptSliceReducer,
  cashier: ownCashierSliceReducer,
  saleSnapshots: ownSaleSnapshotsReducer,
})

export type OwnUiState = ReturnType<typeof ownUiReducer>

/** dispatch store приложения: действия слайсов и thunk transport (`transportRequest`). Пакет не знает RootState. */
export type OwnDispatch = ThunkDispatch<unknown, unknown, UnknownAction>

/**
 * Что хуки окна «Собственной» берут у приложения: свой срез состояния и dispatch. Приложение собирает это из `useAppSelector` и
 * `useAppDispatch`; пакет не импортирует ни store, ни его хуки (D-051).
 */
export interface OwnStore {
  state: OwnUiState
  dispatch: OwnDispatch
}
